import { keyframes } from 'styled-components';

import { TOAST_TRAVEL_DISTANCE } from '@r1-frontend/ui-react/experimental/Toaster/constants';
import { TToastDirection } from '@r1-frontend/ui-react/experimental/Toaster/types';

const getStartPositionByDirection = ({ direction }: { direction: TToastDirection }) => {
    switch (direction) {
        case 'ttb': {
            return keyframes`
                from {
                    transform: translateY(${TOAST_TRAVEL_DISTANCE * -1}px);
                }
            `;
        }
        case 'btt': {
            return keyframes`
                from {
                    transform: translateY(${TOAST_TRAVEL_DISTANCE}px);
                }
            `;
        }
        case 'ltr': {
            return keyframes`
                from {
                    transform: translateX(${TOAST_TRAVEL_DISTANCE * -1}px);
                }
            `;
        }
        case 'rtl': {
            return keyframes`
                from {
                    transform: translateX(${TOAST_TRAVEL_DISTANCE}px);
                }
            `;
        }
    }
};

export default getStartPositionByDirection;
